import { type CommercialReceptionReasonEntity } from "@/features/commercialRegistrationMonitoring/types";
import { getDisplayReceptionReason } from "./getDisplayReceptionReason";

// バックエンドのCSV出力に合わせた読点区切り
const RECEPTION_BOOK_REASON_SEPARATOR = "、";

/**
 * 受付帳が持つ複数の登記原因を表示用の文字列に変換する。
 *
 * バックエンドのCSV出力の区切り文字（読点）に合わせて「、」で結合する。
 * 登記原因テーブル（CommercialReceptionReason）のpk昇順で結合する。
 *
 * @param receptionReasons 受付帳が持つ登記原因一覧
 * @returns 登記原因名を「、」区切りで結合した文字列（該当なしの場合は空文字）
 */
export const getReceptionBookReasonNames = (
  receptionReasons: CommercialReceptionReasonEntity[]
): string =>
  getDisplayReceptionReason(receptionReasons, RECEPTION_BOOK_REASON_SEPARATOR);
